import { render, staticRenderFns } from "./FotoPendukungInputKendaraan.vue?vue&type=template&id=21cd1823&"
import script from "./FotoPendukungInputKendaraan.vue?vue&type=script&lang=js&"
export * from "./FotoPendukungInputKendaraan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports